import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import CustomDevelopment from './components/CustomDevelopment';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <CustomDevelopment />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
